import { render, staticRenderFns } from "./DialogCreateGroup.vue?vue&type=template&id=2996ee30&scoped=true"
import script from "./DialogCreateGroup.js?vue&type=script&lang=js&external"
export * from "./DialogCreateGroup.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2996ee30",
  null
  
)

export default component.exports